import React from "react";
import { Switch, Route } from "react-router-dom";
import Cart from "../components/User/Cart/Cart";
import Checkout from "../components/User/Checkout/Checkout";
import CartCheckout from "../components/User/Checkout/CartCheckout";
import PickAndDrop from "../components/User/PickAndDrop/PickAndDrop";
import RazorPay from "../components/User/Checkout/RazorPay";
import Shop from "../components/User/Shop/Shop";
import Shop2 from "../components/User/Shop/Shop2";
import UserDashboard from "../components/User/SignIn/UserDashboard";
import GMshop from "../components/User/Shop/GMshop";
import Contact from "../components/User/Contact/Contact";
import TermsConditions from "../components/User/Contact/TermsConditions";
import Policy from "../components/User/Contact/Policy";
import Jobs from "../components/User/Contact/Jobs";
import About from "../components/User/Contact/About";
import Terms from "../components/User/FooterPages/Terms";
import PrivacyPolicy from "../components/User/FooterPages/PrivacyPolicy";
import AboutUs from "../components/User/FooterPages/AboutUs";
import ContactUs from "../components/User/FooterPages/ContactUs";
import TravelHack from "../components/User/FooterPages/TravelHack";
import BecomeDriver from "../components/User/Contact/BecomeDriver";
import ForBusiness from "../components/User/Contact/ForBusiness";
import Logistics from "../components/User/Contact/Logistics";
import Product from "../components/User/Product/Product";
import Header from "../components/User/Header/Header";
import Vendor from "../components/User/Vendor/Vendor";
import Vendor1 from "../components/User/Vendor/Vendor1";
import Vendor2 from "../components/User/Vendor/Vendor2";
import SearchResults from "../components/User/Search/SearchResults";
import ResetPassword from "../components/User/SignIn/ResetPassword";
import SignUp from "../components/User/SignUp/SignUp";
import MyOrders from "../components/User/MyOrders/MyOrders";
import Airports from "../components/Flight/Airports";
import FlightResults from "../components/Flight/FlightResults/FlightResults";
import Hotels from "../components/Hotels/Hotels";
import HotelProperties from "../components/Hotels/HotelProperties";
import HotelRooms from "../components/Hotels/HotelRooms";
import HotelRoomsBook from "../components/Hotels/HotelRoomsBook";
import Movies from "../components/Movies/Movies";
import Flights from "../components/Flight/Flights";
import FlightsKiwi from "../components/Flight/FlightsKiwi";
import FlightBook from "../components/Flight/FlightBook";
import FlightBookKiwi from "../components/Flight/FlightBookKiwiV2";
import FlightBookAiriQ from "../components/Flight/FlightBookAiriQ";
import FlightBookFlySmart from "../components/Flight/FlightBookFlySmartV2";
import FlightBookTbo from "../components/Flight/FlightBookTbo";
import T1 from "../components/User/Temp19j/T1";
import T2 from "../components/User/Temp19j/T2";

import Home from "../components/User/Home/Home";
import VendorSuperCategory from "../components/User/VendorSuperCategory/index";
import LiquorVendor from "../components/User/VendorSuperCategory/LiquorVendor";
import Home2 from "../components/User/Home/Home2";
import LiquorShop from "../components/User/Vendor/LiquorShop";
import ProductAndMenus from "../components/User/ProductAndMenus";
import MyOrder from "../components/User/MyOrders/MyOrder";
import RestaurantMenu from "../components/User/ProductAndMenus/RestaurantMenu";
import ScrollToTop from "./ScrollToTop";
import { Rating } from "@material-ui/lab";
import Snackbar from "@material-ui/core/Snackbar";

import HomeScreen from "../pages/Home/Home";

function User() {
  return (
    <div className="App">
      {/* <Snackbar open={true} autoHideDuration={6000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} style={{backgroundColor:'white'}} >
        <Rating name="size-large" defaultValue={2} size="large"/>
      </Snackbar> */}

      <Header />
      <ScrollToTop />
      <Switch>
        <Route exact path="/" component={HomeScreen} />
        <Route exact path="/v1" component={Airports} />
        <Route exact path="/flights/airlines-offer" component={FlightResults} />
        <Route exact path="/hotels" component={Hotels} />
        <Route
          exact
          path="/hotels/search-hotels-properties"
          component={HotelProperties}
        />
        <Route exact path="/hotels/search-hotel-rooms" component={HotelRooms} />
        <Route
          exact
          path="/hotels/book-hotel-room"
          component={HotelRoomsBook}
        />
        <Route exact path="/movies" component={Movies} />
        <Route exact path="/terms" component={Terms} />
        <Route exact path="/privacyPolicy" component={PrivacyPolicy} />
        <Route exact path="/aboutus" component={AboutUs} />
        <Route exact path="/contactus" component={ContactUs} />
        <Route exact path="/travelhack" component={TravelHack} />

        {/* <Route path="/super-category/:id" component={VendorSuperCategory} /> */}
        <Route exact path="/search/:searchText" component={SearchResults} />
        <Route
          exact
          path="/super-category/:superCategoryId"
          component={VendorSuperCategory}
        />
        <Route exact path="/flights" component={Airports} />
        <Route exact path="/flights-search" component={FlightsKiwi} />
        <Route exact path="/flights-search2" component={Flights} />
        <Route exact path="/flights-book2/:orderId" component={FlightBook} />
        <Route
          exact
          path="/flights-book/v1/:orderId"
          component={FlightBookKiwi}
        />
        <Route
          exact
          path="/flights-book/vbook4/:orderId"
          component={FlightBookAiriQ}
        />
        <Route
          exact
          path="/flights-book/:version(V2|v3)/:flightId"
          component={FlightBookFlySmart}
        />
        <Route
          exact
          path="/flights-book/:v4/:flightId"
          component={FlightBookTbo}
        />
        <Route
          exact
          path="/liquor-vendor/:superCategoryId"
          component={LiquorVendor}
        />
        <Route
          exact
          path="/super-category/:superCategoryId/vendor/:vendorId"
          component={ProductAndMenus}
        />
        <Route
          exact
          path="/super-category/:superCategoryId/vendor/:vendorId/restaurant"
          component={RestaurantMenu}
        />
        <Route exact path="/my-profile" component={MyOrder} />
        <Route exact path="/h2" component={Home2} />
        <Route
          path="/shop/:category/:uid/:subCategory/:distance"
          component={Shop}
        />
        <Route
          path="/GMshop/:category/:uid/:subCategory/:distance"
          component={GMshop}
        />
        <Route path="/shop2/:subCategory" component={Shop2} />
        <Route path="/checkout" component={Checkout} />
        <Route path="/cart-checkout" component={CartCheckout} />
        <Route path="/pick-and-drop" component={PickAndDrop} />
        <Route path="/product" component={Product} />
        <Route path="/userDashboard" component={UserDashboard} />
        <Route path="/cart" component={Cart} />
        <Route path="/resetPassword" component={ResetPassword} />
        <Route path="/contact" component={Contact} />
        <Route path="/policy" component={Policy} />
        <Route path="/jobs" component={Jobs} />
        <Route path="/termsConditions" component={TermsConditions} />
        <Route path="/about" component={About} />
        <Route path="/become-driver" component={BecomeDriver} />
        <Route path="/for-business" component={ForBusiness} />
        <Route path="/logistics" component={Logistics} />
        <Route path="/vendors/super/:superCategory" component={Vendor1} />
        <Route path="/vendors/:superCategory" component={Vendor} />
        <Route path="/vendors2/:superCategory" component={Vendor2} />
        <Route path="/signup" component={SignUp} />
        <Route path="/myorders" component={MyOrders} />
        <Route path="/razorpay" component={RazorPay} />
        <Route path="/t1" component={T1} />
        <Route path="/t2" component={T2} />
        <Route path="/liquor/:uid/:distance" component={LiquorShop} />
      </Switch>
    </div>
  );
}

export default User;
